export default {"src":"/_next/static/media/deco_profile_leagues_place_container.cda8a280.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};